import React from 'react';
import { cn } from '../utils';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'primary' | 'secondary';
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
};

const variantClasses = {
  default:
    'border-white border-l-transparent',
  primary:
    'border-t-blue-200 border-r-blue-200 border-b-blue-200 border-l-blue-600',
  secondary:
    'border-t-gray-200 border-r-gray-200 border-b-gray-200 border-l-gray-600',
};

export function Spinner({
  className,
  size = 'md',
  variant = 'default',
  ...props
}: SpinnerProps) {
  return (
    <div
      role="status"
      className={cn(
        'animate-spin rounded-full inline-block border-2',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      {...props}
      />
  );
}
